import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { PropTypes as PropTypes$1 } from '@micromag/core';
import { Button as Button$1 } from '@micromag/core/components';
import { getStyleFromText, getStyleFromBox } from '@micromag/core/utils';

var styles = {"container":"micromag-element-button-container"};

var _excluded = ["textStyle", "buttonStyle", "type", "disabled", "focusable", "inline", "onClick", "children", "className", "withoutExternalBorder", "refButton"],
  _excluded2 = ["body"];
var propTypes = {
  textStyle: PropTypes$1.textStyle,
  buttonStyle: PropTypes$1.boxStyle,
  type: PropTypes.oneOf(['button', 'submit']),
  disabled: PropTypes.bool,
  focusable: PropTypes.bool,
  inline: PropTypes.bool,
  onClick: PropTypes.func,
  children: PropTypes.node,
  className: PropTypes.string,
  withoutExternalBorder: PropTypes.bool,
  refButton: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.any // eslint-disable-line
  })])
};
var defaultProps = {
  textStyle: null,
  buttonStyle: null,
  type: 'button',
  disabled: false,
  focusable: true,
  inline: false,
  onClick: null,
  children: null,
  className: null,
  withoutExternalBorder: true,
  refButton: null
};
var Button = function Button(_ref) {
  var textStyle = _ref.textStyle,
    buttonStyle = _ref.buttonStyle,
    type = _ref.type,
    disabled = _ref.disabled,
    focusable = _ref.focusable,
    inline = _ref.inline,
    onClick = _ref.onClick,
    children = _ref.children,
    className = _ref.className,
    withoutExternalBorder = _ref.withoutExternalBorder,
    refButton = _ref.refButton,
    buttonProps = _objectWithoutProperties(_ref, _excluded);
  var finalStyles = null;
  // eslint-disable-next-line no-unused-vars
  var _ref2 = buttonProps || {};
    _ref2.body;
    var otherProps = _objectWithoutProperties(_ref2, _excluded2);
  if (textStyle !== null) {
    finalStyles = _objectSpread(_objectSpread({}, finalStyles), getStyleFromText(textStyle));
  }
  if (buttonStyle !== null) {
    finalStyles = _objectSpread(_objectSpread(_objectSpread({}, finalStyles), getStyleFromBox(buttonStyle)), {}, {
      display: withoutExternalBorder && inline ? 'inline-block' : null
    });
  }
  if (!withoutExternalBorder) {
    var _ref3 = finalStyles || {},
      _ref3$borderWidth = _ref3.borderWidth,
      borderWidth = _ref3$borderWidth === void 0 ? null : _ref3$borderWidth;
    var margin = borderWidth !== null && borderWidth > 0 ? '-1px' : null;
    finalStyles = _objectSpread(_objectSpread({}, finalStyles), {}, {
      display: inline ? 'inline-block' : null
    }, margin !== null ? {
      margin: margin
    } : null);
  }
  return /*#__PURE__*/React.createElement(Button$1, Object.assign({
    className: classNames([styles.container, _defineProperty({}, className, className !== null)]),
    disabled: disabled,
    style: finalStyles,
    onClick: onClick,
    refButton: refButton,
    type: type,
    focusable: focusable,
    withoutBootstrapStyles: true
  }, otherProps), children);
};
Button.propTypes = propTypes;
Button.defaultProps = defaultProps;

export { Button as default };
